import styled from '@emotion/styled';
import {
  breakpoints,
  fontSize,
  Modal,
  palette,
  spacing,
  Button,
} from '@playdapp/ui';

import Image from '@/components/Image';
import Redirect from '@/components/Redirect';

type Props = {
  isOpen: boolean;
  handleOpen: (isOpen: boolean) => void;
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxl};

  ${breakpoints.down('md')} {
    gap: ${spacing.m};
  }
`;

const ModalTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.s};
`;

const ModalTitle = styled.h3`
  font-size: ${fontSize.h3};
  font-weight: 900;
  text-align: center;

  ${breakpoints.down('md')} {
    font-size: ${fontSize.h5};
  }
`;

const ModalDescription = styled.div`
  font-size: ${fontSize.p3};
  color: ${palette.gray900};
`;

const DescriptionText = styled.p`
  text-align: center;
`;

const ImageBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageBox = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: ${({ theme }) => theme.rem(120)};
  max-height: ${({ theme }) => theme.rem(120)};
  border-radius: 2.5rem;

  ${breakpoints.down('md')} {
    padding: ${spacing.m} ${spacing.s};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${spacing.s};

  button {
    max-width: 418px;
    width: 100%;
    flex: 1;
    font-weight: 600;
  }
`;

const EmailVerifyModal = ({ isOpen, handleOpen }: Props) => (
  <Modal shouldCloseOnOverlayClick isOpen={isOpen} handleOpen={handleOpen}>
    <ModalContent>
      <ImageBlock>
        <ImageBox>
          <Image
            src="/assets/images/email/mail-verified.png"
            height="120px"
            width="120px"
            alt="mail-verified"
          />
        </ImageBox>
      </ImageBlock>
      <ModalTitleBlock>
        <ModalTitle>Verify your E-mail</ModalTitle>
        <ModalDescription>
          <DescriptionText>
            E-mail registration isn&apos;t complete.
          </DescriptionText>
          <DescriptionText>
            Go to the Email Authentication page.
          </DescriptionText>
        </ModalDescription>
      </ModalTitleBlock>
      <ButtonGroup>
        <Redirect to="/email/verification">
          <Button size="lg">Move to page</Button>
        </Redirect>
      </ButtonGroup>
    </ModalContent>
  </Modal>
);

export default EmailVerifyModal;
